import { z } from 'zod';
import { CurrencyCode } from '../schemas/site.js';

export const CurrencyRow = z.object({
  code: CurrencyCode,
  symbol: z.string().min(1),
  decimal_places: z.number().int().min(0).max(4),
});
export type Currency = z.infer<typeof CurrencyRow>;

export const CURRENCIES: readonly Currency[] = [
  { code: 'PLN', symbol: 'zł', decimal_places: 2 },
  { code: 'EUR', symbol: '€',  decimal_places: 2 },
  { code: 'CZK', symbol: 'Kč', decimal_places: 2 },
  { code: 'UAH', symbol: '₴',  decimal_places: 2 },
] as const;

CURRENCIES.forEach((c) => CurrencyRow.parse(c));
